import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { setupPWA } from './utils/pwa';
setupPWA();
render(<App data-id="element-34" />, document.getElementById('root'));